export default __webpack_public_path__ + "static/nicholasChancellor@2x-29fb2c3e10cca974c9f7b87a70cb00e8.jpg";